module.exports = __webpack_public_path__ + "img/icon_cross.e0738fc7.png";